import { useState } from "react";
import { Toaster } from "../components/ui/toaster";
import { Navbar } from "../components/Navbar";
import { SwapsTable } from "../components/SwapsTable";
import { TopupHistory } from "../components/TopUpHistory";
import { Button } from "../components/ui/button";
import { useAuth } from "../AuthProvider";
import RightNavbar from "../components/RightNavbar";

export function History() {
  const { organizationId } = useAuth();

  const [showSwaps, setShowSwaps] = useState(true);

  return (
    <div className="flex min-h-screen w-full">
      <div
        className="flex-grow overflow-x-auto"
        style={{ width: "calc(100% - 60px)" }}
      >
        <div className="flex flex-col w-full mr-0 sm:pr-[40px] lg:pr-[40px]">
          <Navbar />
          <main className="flex flex-1 flex-col gap-4 p-4 md:gap-8 md:p-8">
            <div className="flex justify-center">
              <Button
                onClick={() => setShowSwaps(true)}
                variant={showSwaps ? "default" : "outline"}
                className="mr-2"
              >
                Swaps
              </Button>
              <Button
                onClick={() => setShowSwaps(false)}
                variant={!showSwaps ? "default" : "outline"}
              >
                Top-ups
              </Button>
            </div>
            {!organizationId ? (
              <span>No organization selected</span>
            ) : showSwaps ? (
              <SwapsTable organizationId={organizationId} />
            ) : (
              <TopupHistory organizationId={organizationId} />
            )}
          </main>
        </div>
      </div>
      <RightNavbar />
      <Toaster />
    </div>
  );
}
